import React, { useRef, useEffect, useState } from 'react';
import './App.css';
import Footer from './Footer';

const images = [
  './images/guilin.webp',
  './images/guilin1.webp',
  './images/guilin2.webp',
  './images/guilin3.webp',
];

const TravelForm = () => {
  const carouselRef = useRef(null);
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (carouselRef.current) {
        const container = carouselRef.current;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;

        if (container.scrollLeft >= maxScrollLeft) {
          container.scrollLeft = 0;
        } else {
          container.scrollLeft += 260;
        }
      }
    }, 2000);

    return () => clearInterval(scrollInterval);
  }, []);

  const content = {
    en: `Guilin, located in Guangxi Zhuang Autonomous Region, is renowned for its breathtaking karst mountains, river landscapes, and tranquil countryside. The scenery is so iconic that it appears on the Chinese 20 yuan banknote.

Top places to visit:

• Li River Cruise – A scenic journey through dramatic karst peaks and traditional fishing villages.
• Reed Flute Cave – A limestone cave with illuminated stalactites and stunning formations.
• Elephant Trunk Hill – A natural rock formation shaped like an elephant drinking from the river.
• Longji Rice Terraces – Beautifully layered rice paddies cascading along the mountain slopes.
• Yangshuo – A charming town surrounded by dramatic peaks, popular for cycling, rafting, and nightlife.
• Seven Star Park – The largest park in Guilin with caves, hills, and a zoo.
• Duxiu Peak and Jingjiang Princes' City – A historical site offering panoramic city views.
• Silver Cave – A multilevel cave famous for glittering rock formations and colorful lighting.
• Folded Brocade Hill – Known for its stunning views over Guilin and poetic legend.
• Yulong River – A peaceful tributary of the Li River, ideal for bamboo rafting and countryside exploration.

Guilin is the perfect destination for nature lovers, photographers, and anyone seeking peaceful beauty in the heart of China.`,

    zh: `桂林位于广西壮族自治区，以奇特的喀斯特山水景观闻名中外，“桂林山水甲天下”是对其风光的真实写照。其风景还被印在20元人民币纸币上。

推荐景点：

• 漓江游船 – 沿江而行，欣赏奇峰异石、渔村田园的绝美景色。
• 芦笛岩 – 彩灯点缀的钟乳石洞，洞内景观如梦如幻。
• 象鼻山 – 象形山石如巨象临水而饮，是桂林的地标。
• 龙脊梯田 – 层层叠叠的梯田在山间铺展，四季景色各异。
• 阳朔 – 山水环绕的小镇，适合骑行、漂流、夜生活丰富。
• 七星公园 – 桂林最大公园，山洞、岩石、动物园等设施齐全。
• 独秀峰和靖江王城 – 历史遗迹，可俯瞰整个桂林市。
• 银子岩 – 层层叠叠的洞穴，钟乳石在灯光下熠熠生辉。
• 叠彩山 – 登高望远的好去处，因其如锦绣叠起而得名。
• 遇龙河 – 漓江的支流，适合竹筏漂流和乡村探索。

桂林是摄影爱好者与自然爱好者的天堂，其宁静的山水风光令人心旷神怡、流连忘返。`
  };

  return (
    <div className="travel-form-container2">
      {/* Row 1 - Description */}
      <div className="row row-one2">
        <div className="col image-col2">
          <img src="./images/guilin2.webp"  className="travel-image2" />
          <img src="./images/guilin.webp" className="travel-image2" />
        </div>

        <div className="col content-col2">
          <h2>Guilin</h2>

          {/* Language Toggle Button */}
          <div style={{ textAlign: 'right', marginBottom: '10px' }}>
            <button
              onClick={() => setLang(lang === 'en' ? 'zh' : 'en')}
              style={{
                padding: '8px 16px',
                borderRadius: '6px',
                border: 'none',
                backgroundColor: '#967969',
                color: 'white',
                cursor: 'pointer'
              }}
            >
              {lang === 'en' ? '切换到中文' : 'Switch to English'}
            </button>
          </div>

          {/* Paragraph */}
          <p style={{ whiteSpace: 'pre-line' }}>{content[lang]}</p>
        </div>
      </div>

      {/* Row 2 - Auto Carousel */}
      <div className="carousel-container2">
        <div className="carousel-heading-column">
          <h2 className="carousel-heading">Explore Guilin</h2>
          <p className="carousel-subheading">
            Drift through karst peaks, ancient caves, and serene river valleys.
          </p>
        </div>

        <div className="carousel2" ref={carouselRef}>
          {images.map((imgSrc, index) => (
            <img key={index} src={imgSrc} className="carousel-image2" />
          ))}
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TravelForm;
